export function mapLocationToForm(location: any) {
  const addr = location?.address || {};

  return {
    city: addr.city || "",
    district: addr.district || "",
    state: addr.state || "",
    pincode: addr.pincode || "",
  };
}

export function buildPayload(
  formData: any,
  locationData: any,
  patientId: number,
) {
  return {
    ...formData,
    patientId,
    countryCode: parseInt(formData.countryCode || "91"),
    phoneNo: parseInt(formData.phoneNo),
    pincode: parseInt(formData.pincode),

    coordinates: {
      latitude: locationData?.latLng?.lat,
      longitude: locationData?.latLng?.lng,
    },
  };
}
